/**
 * @generated SignedSource<<4dda464cc277b67747160f270309f805>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductCarouselItem_photos$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductImage_photo">;
  readonly " $fragmentType": "ProductCarouselItem_photos";
};
export type ProductCarouselItem_photos$key = {
  readonly " $data"?: ProductCarouselItem_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductCarouselItem_photos">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductCarouselItem_photos",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductImage_photo"
    }
  ],
  "type": "ItemPhoto",
  "abstractKey": null
};

(node as any).hash = "5d528acfb39a2729d0f71b66f2685c55";

export default node;
